__turbopack_context__.v({
  "card": "CommentCard-module-scss-module__lZvRwW__card",
  "cardContent": "CommentCard-module-scss-module__lZvRwW__cardContent",
  "postContent": "CommentCard-module-scss-module__lZvRwW__postContent",
  "repliedTo": "CommentCard-module-scss-module__lZvRwW__repliedTo",
  "textContent": "CommentCard-module-scss-module__lZvRwW__textContent",
  "title": "CommentCard-module-scss-module__lZvRwW__title",
});
